<p-toast></p-toast>
<p-panel header="Asset Codes Group Distinct">
  <ng-template #icons>
    <div class="flex gap-2">
      <!-- Add Button -->
      <p-button icon="pi pi-plus" label="Add" severity="primary" (onClick)="addNew()" [disabled]="loading()" outlined>
      </p-button>

      <!-- Edit Button -->
      <p-button icon="pi pi-pencil" label="Edit" severity="secondary" (onClick)="editAssetCodesGroupDistinct()"
        [disabled]="selectedAssetCodesGroupDistincts().length !== 1 || loading()" outlined>
      </p-button>

      <!-- Delete Button -->
      <p-button icon="pi pi-trash" [label]="deleteButtonLabel()" severity="danger"
        (onClick)="deleteAssetCodesGroupDistinct()"
        [disabled]="selectedAssetCodesGroupDistincts().length === 0 || loading()" outlined>
      </p-button>

      <!-- Refresh Button -->
      <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" (onClick)="refreshAssetCodesGroupDistinct()"
        [disabled]="loading()" outlined>
      </p-button>

      <!-- History Button -->
      <p-button icon="pi pi-history" label="History" severity="secondary" (onClick)="showHistory()"
        [disabled]="loading() || selectedAssetCodesGroupDistincts().length !== 1" outlined>
      </p-button>
    </div>
  </ng-template>
  <ng-template #content>
    <!-- Search Panel -->
    <div class="mb-4 p-4 bg-surface-50 rounded-lg border border-surface-200">
      <div class="mb-3">
        <label for="assetCodesGroupDistinctSearch" class="block text-sm font-medium text-surface-700 mb-1">Search by
          Asset Group Name or Asset Group Code</label>
        <div class="flex items-center gap-2">
          <div class="flex-1">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input id="assetCodesGroupDistinctSearch" pInputText type="text" [(ngModel)]="keywords"
                (ngModelChange)="onFilter($event)" placeholder="Enter search terms..." autocomplete="off" />
            </p-iconfield>
          </div>
          <p-button *ngIf="keywords.trim()" icon="pi pi-times" label="Clear Search" severity="secondary" size="small"
            (onClick)="clearFilter()" outlined>
          </p-button>
        </div>
      </div>
    </div>

    <p-divider></p-divider>
    <p-table [value]="(assetCodesGroupDistinct() || [])" [totalRecords]="(totalRecords() || 0)" [paginator]="true"
      [rows]="rows" [first]="first" [lazy]="true" [loading]="loading()" [loadingIcon]="'pi pi-spin pi-cog'"
      [tableStyle]="{ 'min-width': '30rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} asset codes groups"
      paginatorDropdownAppendTo="body" [rowsPerPageOptions]="[10, 25, 50]" (onPage)="onPage($event)" selectionMode="multiple"
      [(selection)]="selectedAssetCodesGroupDistincts" (selectionChange)="selectedAssetCodesGroupDistincts.set($event)"
      dataKey="id" size="small">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Asset Group Name</th>
          <th>Asset Group Code</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-assetCodesGroupDistinct>
        <tr [pSelectableRow]="assetCodesGroupDistinct">
          <td>
            <p-tableCheckbox [value]="assetCodesGroupDistinct"></p-tableCheckbox>
          </td>
          <td>{{ assetCodesGroupDistinct.asset_group_name }}</td>
          <td>{{ assetCodesGroupDistinct.asset_group_code }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center p-4">No asset codes groups found</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-panel>

<p-confirmDialog></p-confirmDialog>

<p-dialog [visible]="dialogVisible()" (visibleChange)="dialogVisible.set($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [closable]="false" [dismissableMask]="true" [closeOnEscape]="true" [style]="{width: '450px'}">
  <ng-template #header>
    <h3 class="text-lg font-medium text-surface-900">{{ isEditMode() ? 'Edit Asset Codes Group Distinct' : 'Add Asset
      Codes Group Distinct' }}</h3>
  </ng-template>

  <div class="mb-4 mt-2 flex flex-col gap-2">
    <label for="assetGroupName" class="font-medium">Asset Group Name</label>
    <input id="assetGroupName" type="text" pInputText [ngModel]="assetGroupName()"
      (ngModelChange)="assetGroupName.set($event)" placeholder="Enter asset group name" class="w-full">
  </div>

  <div class="mb-4 flex flex-col gap-2">
    <label for="assetGroupCode" class="font-medium">Asset Group Code</label>
    <input id="assetGroupCode" type="text" pInputText [ngModel]="assetGroupCode()"
      (ngModelChange)="assetGroupCode.set($event)" placeholder="Enter asset group code" class="w-full">
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" (onClick)="closeDialog()" [disabled]="savingAssetCodesGroupDistinct()"
      styleClass="p-button-text">
    </p-button>
    <p-button [label]="isEditMode() ? 'Update' : 'Save'" icon="pi pi-check" (onClick)="saveAssetCodesGroupDistinct()"
      [disabled]="savingAssetCodesGroupDistinct()" [loading]="savingAssetCodesGroupDistinct()">
    </p-button>
  </ng-template>
</p-dialog>

<app-asset-history-dialog
  [(visible)]="historyVisible"
  [resourceName]="auditResourceName"
  [recordId]="historyRecordId"
  [recordLabel]="historyRecordLabel">
</app-asset-history-dialog>
